module.exports = __webpack_public_path__ + "static/media/suite3.0ed5d9b8.png";